import { render, staticRenderFns } from "./LoadConfigurationComponent.vue?vue&type=template&id=206704ac"
import script from "./LoadConfigurationComponent.vue?vue&type=script&lang=js"
export * from "./LoadConfigurationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports